import { ReactNode } from "react";
import { Unlink02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Button, ButtonSize, ButtonVariant, Show } from "shared/components";
import { BreadCrumbs } from "shared/components/BreadCrumbs";
import { IntegrationLogoIcon } from "views/settings-integration/components/IntegrationLogoIcon";
import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";

interface IntegrationDetailHeaderProps {
  id: IntegrationId;
  name: string;
  path: string;
  integrationType?: string;
  onDisconnect?: () => void;
  isDisconnecting?: boolean;
  actions?: ReactNode;
}

export const IntegrationDetailHeader = ({
  id,
  name,
  path,
  integrationType = name,
  onDisconnect,
  isDisconnecting,
  actions
}: IntegrationDetailHeaderProps): ReactNode => (
  <>
    <div className="flex items-center justify-between border-b border-alpha-40 px-3 pt-3 pb-6 md:px-6">
      <BreadCrumbs
        crumbs={[
          { title: "Settings", href: "/settings" },
          { title: "Integration", href: "/settings/integration" },
          { title: name, href: path }
        ]}
      />
    </div>
    <div className="flex items-center justify-between border-b border-alpha-40 px-6 py-4">
      <div className="flex items-center gap-4">
        <IntegrationLogoIcon id={id} size="SM" />
        <p className="text-xl font-bold text-content-1000">{name}</p>
      </div>
      <div className="flex items-center gap-2">
        {actions}
        <Show if={Boolean(onDisconnect)}>
          <Button
            variant={ButtonVariant.BASE}
            size={ButtonSize.SM}
            HugeIcon={Unlink02Icon}
            onClick={onDisconnect}
            loading={isDisconnecting}
          >
            Disconnect
          </Button>
        </Show>
      </div>
    </div>
    <div className="space-y-2 px-6 pb-1 pt-4">
      <p className="text-xs text-content-400">Integration type</p>
      <p className="text-sm font-medium text-content-1000">{integrationType}</p>
    </div>
  </>
);
